import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext, useEffect } from "react";

import {
  Context,
  fetchCareerLatestSheet,
  fetchCareerFeedbackSheets,
  fetchCareerFeedbackQuestions,
  createCareerSheets,
  APPLY_FOR_CAREER_MAP_GENERATION_SUCCESS_MESSAGE,
} from "../../../store/student";
import LoginHeader from "../../../organisms/LoginHeader";
import Career from "../../../templates/Career";
import styles from "../common.module.scss";

const CareerPage = () => {
  const { contextState, dispatch } = useContext(Context);

  useIonViewWillEnter(() => {
    dispatch(fetchCareerLatestSheet());
    dispatch(fetchCareerFeedbackSheets());
    dispatch(fetchCareerFeedbackQuestions());
  });

  // キャリア開拓シート画面からのリダイレクト直後では最新データを取得できないため、キャリア開拓MAP申請の成功後に再取得
  useEffect(() => {
    if (
      contextState.success_message ===
      APPLY_FOR_CAREER_MAP_GENERATION_SUCCESS_MESSAGE
    ) {
      dispatch(fetchCareerLatestSheet());
      dispatch(fetchCareerFeedbackSheets());
    }
  }, [dispatch, contextState.success_message]);

  const createCareerSheetsFunc = () => {
    dispatch(createCareerSheets());
  };

  return (
    <IonPage>
      <LoginHeader title="キャリア開拓モード" unreadNotiCount={0} />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <Career createCareerSheets={createCareerSheetsFunc} />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CareerPage;
